import { EventDispatcher } from "three";
/**
 * Events dispatcher to execute events logic inside contextInit.
 */
export class ContextBase extends EventDispatcher {
    /**
     * Gets the current state.
     */
    get state() {
        return this._state;
    }
    /**
     * Initialize the state here when use it. this._state = new loading(this);
     */
    constructor() {
        super();
    }
    /**
     * Triggers an event and set new state if necessary.
     */
    handle(event, args) {
        const newState = this._state.handle(event, args);
        if (this._state.type !== newState.type) {
            this._state = this.changeState(newState);
            this._state.onAfterInit();
        }
    }
}
//# sourceMappingURL=Context.js.map